import { Icon } from '@adobe/react-spectrum';

const LeftSidebarOpenIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 9.2502H13.2748L12.3525 8.26192C12.0693 7.95919 12.0859 7.48458 12.3887 7.20137C12.6904 6.92012 13.166 6.93575 13.4482 7.23848L15.5479 9.48848C15.8174 9.77657 15.8174 10.2238 15.5479 10.5119L13.4482 12.7619C13.3008 12.9201 13.1006 13.0002 12.9004 13.0002C12.7168 13.0002 12.5332 12.9338 12.3887 12.799C12.0859 12.5158 12.0693 12.0412 12.3525 11.7385L13.2748 10.7502H10V9.2502Z"
          fill="#0265DC"
        />
        <path
          d="M4.25 2H15.75C16.9902 2 18 3.00977 18 4.25V15.75C18 16.9902 16.9902 18 15.75 18H4.25C3.00977 18 2 16.9902 2 15.75V4.25C2 3.00977 3.00977 2 4.25 2ZM16.5 15.75V4.25C16.5 3.83691 16.1631 3.5 15.75 3.5H10V9.25H6.72522L7.64746 8.26172C7.93066 7.95899 7.91406 7.48438 7.61133 7.20117C7.30957 6.91992 6.83496 6.93555 6.55176 7.23828L4.45215 9.48828C4.18262 9.77637 4.18262 10.2236 4.45215 10.5117L6.55176 12.7617C6.69922 12.9199 6.89942 13 7.09961 13C7.2832 13 7.4668 12.9336 7.61133 12.7988C7.91406 12.5156 7.93067 12.041 7.64746 11.7383L6.72522 10.75H10V16.5H15.75C16.1631 16.5 16.5 16.1631 16.5 15.75Z"
          fill="#0265DC"
        />
      </svg>
    </Icon>
  );
};

export default LeftSidebarOpenIcon;
